<template>
  <font-awesome-icon
    icon="bookmark"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBookmark } from '@fortawesome/free-solid-svg-icons'

library.add(faBookmark)

export default {
  name: 'CoozzyBookmarkIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
